import { Theme } from '@mui/material/styles/createTheme'
import React from 'react'
import { useMediaQuery, Stack } from '@mui/material'
import { About } from './About'
import { Contact } from './Contact'

export const OpenFooter: React.FC = () => {
  const mdUp = useMediaQuery<Theme>((theme) => theme.breakpoints.up('md'))

  return (
    <Stack
      direction={mdUp ? 'row' : 'column'}
      justifyContent="space-between"
      pl={{ md: 3 }}
      mb={4}
      gap={5}
      ml="auto"
    >
      <About />
      <Contact />
    </Stack>
  )
}
